<template>
  <v-dialog :model-value="modelValue" max-width="440px" @update:model-value="$emit('update:modelValue', $event)">
    <v-card class="delete-confirm-dialog">
      <v-card-title class="dialog-header">
        <span class="dialog-header-title">
          <v-icon class="mr-2" color="error">mdi-alert-circle</v-icon>
          {{ title }}
        </span>
        <button
          type="button"
          class="dialog-close"
          aria-label="닫기"
          :disabled="loading"
          @click="$emit('update:modelValue', false)"
        >
          <v-icon size="18">mdi-close</v-icon>
        </button>
      </v-card-title>
      <v-card-text>
        <p class="delete-confirm-body">
          <strong>{{ targetName }}</strong>
          {{ message }}
        </p>
        <div class="delete-confirm-warning" role="alert">
          <v-icon size="20" color="#b71c1c">mdi-alert-octagon</v-icon>
          <p>{{ warning }}</p>
        </div>
      </v-card-text>
      <v-card-actions class="dialog-actions">
        <v-spacer />
        <v-btn variant="text" class="btn-cancel" @click="$emit('update:modelValue', false)" :disabled="loading">취소</v-btn>
        <v-btn variant="flat" class="btn-delete" @click="$emit('confirm')" :loading="loading">삭제</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
interface Props {
  modelValue: boolean;
  title: string;
  targetName: string;
  message: string;
  warning?: string;
  loading?: boolean;
}

withDefaults(defineProps<Props>(), {
  loading: false,
  warning: '이 작업은 되돌릴 수 없습니다.',
});

defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
  (e: 'confirm'): void;
}>();
</script>
